import React from "react";
import { Button } from "react-bootstrap";
import FiChevronUp from "../../../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../../../constants/icons/Fi/FiChevronDown";
import withSubscriptionCheckButton from "../../../../components/Common/withSubscriptionCheckButton";
import TestItem from "./TestItem";

const ViewButton = withSubscriptionCheckButton(
  Button,
  "Practice",
  true,
  false,
  "student-practice-view-attempts my-0"
);

const MobileView = ({
  sectionsList,
  selectedSections,
  setSelectedSections,
  selectedMobileTopic,
  setSelectedMobileTopic,
  roleOfTheUser,
  classroomId,
  activeTab,
  hasValidSubscription,
  onViewAllAttempts,
  isLoading,
  renderTestButton,
}) => {
  return (
    <div
      className="d-block d-lg-none col-12"
      style={{
        marginTop: "15px",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      {sectionsList?.length ? (
        <div className="d-flex justify-content-start align-items-center my-2">
          {roleOfTheUser === "Student" ? (
            <ViewButton
              onClick={onViewAllAttempts}
              classRoomId={classroomId}
              requiredFeature="Practice"
              hasValidSubscription={hasValidSubscription}
              subjects={[activeTab]}
              index={0}
            >
              View Attempts
            </ViewButton>
          ) : (
            <Button
              className="student-practice-view-attempts my-0"
              onClick={onViewAllAttempts}
            >
              View Attempts
            </Button>
          )}
        </div>
      ) : (
        ""
      )}
      <div className="p-0 bg-white">
        {!isLoading && sectionsList?.length ? (
          sectionsList.map((section, index) => {
            const isSelected = selectedSections.some(
              (selec) => selec === section?._id
            );
            return (
              <div key={index}>
                <div
                  className="d-flex justify-content-between"
                  style={{
                    background: "#F5F7FA",
                    border: "1px solid #E9EAF0",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "22px",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      color: "#564FFD",
                    }}
                    onClick={() => {
                      if (isSelected) {
                        setSelectedSections(
                          selectedSections.filter(
                            (selec) => selec !== section?._id
                          )
                        );
                      } else {
                        setSelectedSections([
                          ...selectedSections,
                          section?._id,
                        ]);
                      }
                    }}
                  >
                    {isSelected ? (
                      <FiChevronUp
                        size={20}
                        style={{ marginRight: "8px", cursor: "pointer" }}
                      />
                    ) : (
                      <FiChevronDown
                        size={20}
                        style={{ marginRight: "8px", cursor: "pointer" }}
                      />
                    )}{" "}
                    {section?.name}
                  </div>
                </div>
                {isSelected ? (
                  section?.topics?.length ? (
                    <div className="py-2">
                      {section?.topics?.map((topic, index) => {
                        const isTopicSelected = selectedMobileTopic.some(
                          (selec) => selec === topic?._id
                        );
                        return (
                          <>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "22px",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                color: "#4E5566",
                                padding: "12px 20px 12px 20px",
                                border: "1px solid #F5F7FA",
                              }}
                              key={`top-${index}`}
                              onClick={() => {
                                if (isTopicSelected) {
                                  setSelectedMobileTopic(
                                    selectedMobileTopic.filter(
                                      (selec) => selec !== topic?._id
                                    )
                                  );
                                } else {
                                  setSelectedMobileTopic([
                                    ...selectedMobileTopic,
                                    topic?._id,
                                  ]);
                                }
                              }}
                            >
                              <div className="d-flex align-items-center gap-2">
                                {topic?.name}
                                {/* Mastery badge logic same as desktop */}
                                {(() => {
                                  // Desktop logic for badge
                                  const isValidScore = (score) =>
                                    typeof score === "number" && !isNaN(score);
                                  const allTestsAttempted = Array.isArray(
                                    topic?.tests
                                  )
                                    ? topic.tests.length > 0 &&
                                      topic.tests.every((t) =>
                                        isValidScore(t.score)
                                      )
                                    : true; // If no tests, treat as true
                                  const hasAnySets =
                                    Array.isArray(topic?.tests) &&
                                    topic.tests.length > 0;
                                  const allAttempted =
                                    hasAnySets && allTestsAttempted;
                                  const topicScore =
                                    typeof topic.score === "string"
                                      ? parseFloat(topic.score)
                                      : topic.score;
                                  let badge = null;
                                  if (allAttempted) {
                                    if (topicScore >= 90) badge = "Champion";
                                    else if (topicScore > 60 && topicScore < 90)
                                      badge = "Challenger";
                                    else badge = "Rookie";
                                  } else {
                                    if (topicScore > 60) badge = "Challenger";
                                    else badge = "Rookie";
                                  }
                                  return badge ? (
                                    <span
                                      className={`topic-badge ${badge.toLowerCase()}`}
                                    >
                                      {badge}
                                    </span>
                                  ) : null;
                                })()}
                              </div>
                              <div>
                                {isTopicSelected ? (
                                  <FiChevronUp size={20} />
                                ) : (
                                  <FiChevronDown size={20} />
                                )}
                              </div>
                            </div>
                            {isTopicSelected ? (
                              <>
                                {topic?.tests?.length ? (
                                  <div>
                                    {topic?.tests.map((test, testInd) => (
                                      <TestItem
                                        key={testInd}
                                        test={test}
                                        testInd={testInd}
                                        topic={topic}
                                        renderTestButton={renderTestButton}
                                      />
                                    ))}
                                  </div>
                                ) : (
                                  <p
                                    className="px-4 py-3"
                                    style={{
                                      color: "#6E7485",
                                      fontSize: "12px",
                                    }}
                                  >
                                    No tests found.
                                  </p>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="p-4">
                      No topics present in this section.
                    </div>
                  )
                ) : (
                  ""
                )}
                <div style={{ border: "1px solid #E9EAF0" }} />
              </div>
            );
          })
        ) : !isLoading && sectionsList?.length === 0 ? (
          <div className="p-4">No sections present in this subject.</div>
        ) : null}
      </div>
    </div>
  );
};

export default MobileView;
